import { JsonPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { PvzAddressValue } from 'src/app/shared/models/pvz-address.model';
import { PaPvzAddressInputComponent } from 'src/app/shared/ui-kit/pa-pvz-address-input/pa-pvz-address-input.component';
import { pvzAddressSelectedValidator } from 'src/app/shared/validators/pvz-address.validator';

@Component({
  selector: 'app-pvz-address-input-view',
  standalone: true,
  imports: [
    PaPvzAddressInputComponent,
    ReactiveFormsModule,
    JsonPipe,
  ],
  templateUrl: './pvz-address-input-view.component.html',
  styleUrls: ['./pvz-address-input-view.component.scss'],
})
export class PvzAddressInputViewComponent {
  private readonly fb = inject(FormBuilder);

  readonly apiEndpointHint = 'GET /v2/pvzs/open_street_map/{search}';

  formDefault = this.fb.group({
    address: new FormControl<PvzAddressValue | null>(null),
  });

  formRequired = this.fb.group({
    address: new FormControl<PvzAddressValue | null>(null, [
      Validators.required,
      pvzAddressSelectedValidator,
    ]),
  });

  formInvalid = this.fb.group({
    address: new FormControl<PvzAddressValue | null>(null, [
      Validators.required,
      pvzAddressSelectedValidator,
    ]),
  });

  get selectedValue(): PvzAddressValue | null {
    return this.formDefault.get('address')?.value ?? null;
  }
}
